import { render, staticRenderFns } from "./observed_3.vue?vue&type=template&id=1402a677&scoped=true&"
var script = {}
import style0 from "./observed_3.vue?vue&type=style&index=0&id=1402a677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1402a677",
  null
  
)

export default component.exports